import { apiClient } from './client';
import { downloadPdfBlob } from '../utils/downloadPdf';
import { ComplaintAsCase, ComplaintAsCasePayload } from '../types/complaintAs';
import { SequentialCodeSuggestion } from '../types/sequentialCode';

export async function fetchComplaintAsCases(keyword?: string): Promise<ComplaintAsCase[]> {
  const { data } = await apiClient.get<ComplaintAsCase[]>('/complaint-as-cases', {
    params: keyword?.trim() ? { q: keyword.trim() } : undefined,
  });
  return data;
}

export async function fetchComplaintAsCase(caseId: number): Promise<ComplaintAsCase> {
  const { data } = await apiClient.get<ComplaintAsCase>(`/complaint-as-cases/${caseId}`);
  return data;
}

export async function fetchNextComplaintAsCaseNo(): Promise<SequentialCodeSuggestion> {
  const { data } = await apiClient.get<SequentialCodeSuggestion>(
    '/complaint-as-cases/suggestions/case-no'
  );
  return data;
}

export async function createComplaintAsCase(
  payload: ComplaintAsCasePayload
): Promise<ComplaintAsCase> {
  const { data } = await apiClient.post<ComplaintAsCase>('/complaint-as-cases', payload);
  return data;
}

export async function updateComplaintAsCase(
  caseId: number,
  payload: ComplaintAsCasePayload
): Promise<ComplaintAsCase> {
  const { data } = await apiClient.patch<ComplaintAsCase>(
    `/complaint-as-cases/${caseId}`,
    payload
  );
  return data;
}

export async function closeComplaintAsCase(caseId: number): Promise<ComplaintAsCase> {
  const { data } = await apiClient.post<ComplaintAsCase>(`/complaint-as-cases/${caseId}/close`);
  return data;
}

export async function reopenComplaintAsCase(caseId: number): Promise<ComplaintAsCase> {
  const { data } = await apiClient.post<ComplaintAsCase>(`/complaint-as-cases/${caseId}/reopen`);
  return data;
}

export async function approveComplaintAsCase(caseId: number): Promise<ComplaintAsCase> {
  const { data } = await apiClient.post<ComplaintAsCase>(
    `/complaint-as-cases/${caseId}/approve`
  );
  return data;
}

export async function revokeComplaintAsCase(caseId: number): Promise<ComplaintAsCase> {
  const { data } = await apiClient.post<ComplaintAsCase>(
    `/complaint-as-cases/${caseId}/revoke`
  );
  return data;
}

export async function deleteComplaintAsCase(caseId: number): Promise<void> {
  await apiClient.delete(`/complaint-as-cases/${caseId}`);
}


export async function downloadComplaintAsPdf(
  caseId: number,
  fileName?: string
): Promise<void> {
  await downloadPdfBlob(
    `/complaint-as-cases/${caseId}/pdf`,
    fileName || `불만AS_${caseId}.pdf`
  );
}
